export default __webpack_public_path__ + "static/media/davidBowie.d9c7fce2.jpeg";